import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import {
  completeOnboarding,
  getOnboardingComplete,
} from '../lib/services/onboardingService';

export function useOnboardingStatus() {
  const { user } = useAuth();
  const [complete, setComplete] = useState(true);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!user?.id) {
      setComplete(true);
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const { complete: isComplete } = await getOnboardingComplete();
      setComplete(isComplete);
    } finally {
      setLoading(false);
    }
  }, [user?.id]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const markComplete = useCallback(async () => {
    const { error } = await completeOnboarding();
    if (error) {
      throw error;
    }
    setComplete(true);
  }, []);

  return { complete, loading, refresh, markComplete };
}
